(function () {
  'use strict';

  var root = document.querySelector('[data-yarndogs-privacy-root]');
  if (!root) return;

  var openButton = root.querySelector('[data-yarndogs-privacy-open]');
  var dialog = root.querySelector('[data-yarndogs-privacy-dialog]');
  var closeButton = root.querySelector('[data-yarndogs-privacy-close]');
  var saveButton = root.querySelector('[data-yarndogs-privacy-save]');
  var rejectButton = root.querySelector('[data-yarndogs-privacy-reject]');
  var acceptButton = root.querySelector('[data-yarndogs-privacy-accept]');
  var status = root.querySelector('[data-yarndogs-privacy-status]');
  var checkboxes = {
    preferences: root.querySelector('[data-yarndogs-privacy-category="preferences"]'),
    analytics: root.querySelector('[data-yarndogs-privacy-category="analytics"]'),
    marketing: root.querySelector('[data-yarndogs-privacy-category="marketing"]'),
  };
  var apiPromise;

  function setStatus(message, isError) {
    status.textContent = message || '';
    status.hidden = !message;
    status.setAttribute('role', isError ? 'alert' : 'status');
  }

  function loadApi() {
    if (window.Shopify && window.Shopify.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (apiPromise) return apiPromise;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return Promise.reject(new Error('Customer Privacy API is unavailable.'));
    }
    apiPromise = new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (!settled) { settled = true; reject(new Error('Customer Privacy API load timed out.')); }
      }, 8000);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        if (error || !window.Shopify.customerPrivacy) {
          reject(error || new Error('Customer Privacy API did not load.'));
        } else {
          resolve(window.Shopify.customerPrivacy);
        }
      });
    }).catch(function (error) {
      apiPromise = null;
      throw error;
    });
    return apiPromise;
  }

  function valueIsYes(value) {
    return value === true || value === 'yes';
  }

  function fillFromConsent(consent) {
    consent = consent || {};
    Object.keys(checkboxes).forEach(function (category) {
      if (checkboxes[category]) checkboxes[category].checked = valueIsYes(consent[category]);
    });
  }

  function readConsent(api) {
    if (typeof api.currentVisitorConsent !== 'function') return {};
    return api.currentVisitorConsent() || {};
  }

  function setConsent(values) {
    setStatus('Saving your preferences…', false);
    [saveButton, rejectButton, acceptButton].forEach(function (button) { if (button) button.disabled = true; });
    return loadApi().then(function (api) {
      return new Promise(function (resolve, reject) {
        var settled = false;
        var timer = window.setTimeout(function () {
          if (!settled) { settled = true; reject(new Error('Customer Privacy API save timed out.')); }
        }, 10000);
        api.setTrackingConsent(values, function (result) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          var error = typeof result === 'string' ? result : result && (result.error || result.message);
          if (error) {
            reject(new Error(error));
          } else {
            resolve();
          }
        });
      });
    }).then(function () {
      setStatus('Your preferences were saved.', false);
      if (dialog && typeof dialog.close === 'function') dialog.close();
      document.dispatchEvent(new CustomEvent('yarndogsPrivacyPreferencesSaved'));
    }).catch(function (error) {
      setStatus('We could not save your preferences. Please try again.', true);
      if (window.console && console.warn) console.warn('[Yarndogs privacy]', error);
    }).then(function () {
      [saveButton, rejectButton, acceptButton].forEach(function (button) { if (button) button.disabled = false; });
    });
  }

  function openPreferences() {
    setStatus('', false);
    loadApi().then(function (api) {
      fillFromConsent(readConsent(api));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      else if (dialog) dialog.setAttribute('open', '');
    }).catch(function () {
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      else if (dialog) dialog.setAttribute('open', '');
      setStatus('Cookie preferences are temporarily unavailable. The Your Privacy Choices page remains available for data-sharing opt-out.', true);
    });
  }

  openButton.addEventListener('click', openPreferences);
  if (closeButton) closeButton.addEventListener('click', function () { if (dialog && typeof dialog.close === 'function') dialog.close(); });
  if (saveButton) saveButton.addEventListener('click', function () {
    setConsent({ preferences: !!checkboxes.preferences.checked, analytics: !!checkboxes.analytics.checked, marketing: !!checkboxes.marketing.checked });
  });
  if (rejectButton) rejectButton.addEventListener('click', function () {
    setConsent({ preferences: false, analytics: false, marketing: false });
  });
  if (acceptButton) acceptButton.addEventListener('click', function () {
    setConsent({ preferences: true, analytics: true, marketing: true });
  });
  if (dialog) dialog.addEventListener('click', function (event) {
    if (event.target === dialog && typeof dialog.close === 'function') dialog.close();
  });
  document.addEventListener('visitorConsentCollected', function () {
    loadApi().then(function (api) { fillFromConsent(readConsent(api)); }).catch(function () {});
  });
}());
